import { dollarsToNum } from "@oneethos/shared";
import { LoanOption } from "@oneethos/shared/loan-option";
import { useEffect, useRef } from "react"

type EmbedCommercialScenariosProps = {
  loanOptions?: LoanOption[]
  formData?: any
}

export const EmbedCommercialScenarios = ({ loanOptions, formData }: EmbedCommercialScenariosProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null)
  const cheapest = loanOptions?.[0]
  const params: any = {
    p: 'T25lRXRob3M2MTMyNWFzZGZsa2phc2'
  }

  if (cheapest && formData?.loanAmount) {
    params.b = dollarsToNum(formData.avgMonthlyUtilityBill).toFixed(2) // before
    params.af = dollarsToNum(formData.estAvgMonthlyUtilityBillAfterSolar).toFixed(2) // after
    params.pc = dollarsToNum(formData.loanAmount).toFixed(2)  // project cost
  }

  const query = new URLSearchParams(params)

  useEffect(() => {
    const iframe = iframeRef.current;
    const allowedOrigin = new URL(iframe.src).origin; // lock down if you know it
    const handleMessage = (e: MessageEvent) => {
      if (e.origin !== allowedOrigin) return              // security (or drop this line if you must)
      if (!e.data || e.data.type !== 'embed-size') return // ignore other messages
      iframe.style.height = e.data.height + 'px'
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  return <iframe src={`https://www.oneethos.com/scenarios-embed?${query.toString()}`}
    style={{ width: '100%', height: 2000, border: 0 }} 
    scrolling="no"
    ref={iframeRef}
  />
}